import React, { ReactNode } from 'react';
import { GroupBase, InputActionMeta, OptionsOrGroups } from 'react-select';
import AsyncSelect from 'react-select/async';

import { getClassName } from '../input-class';
import useAsyncSelectInputSingle from './async-select-input-single.controller';

const ID = 'async-select-input-single';
export interface AsyncSelectInputSingleProps {
    isClearable?: boolean;
    isDisabled?: boolean;
    cacheOptions?: any;
    loadOptions?: (
        inputValue: string,
        callback: (options: OptionsOrGroups<any, GroupBase<any>>) => void
    ) => void | Promise<OptionsOrGroups<any, GroupBase<any>>>;
    options?: { value: string; label: string }[];
    placeholder?: ReactNode;
    noOptionsMessage?: (obj: { inputValue: string }) => ReactNode;
    onChange: (newValue: { value: string; label: string }) => void;
    onInputChange?: ((newValue: string, actionMeta: InputActionMeta) => void) | undefined;
    onMenuScrollToBottom?: (event: WheelEvent | TouchEvent) => void;
    id?: string;
    required?: boolean;
    label: React.ReactNode;
    valid?: boolean;
    isValidCallback?: (valid: boolean) => void;
    onFocusChange?: () => void;
    submitted: boolean;
    value?: string;
    useConditionedStyling?: boolean;
    className?: string;
    errorMessage?: React.ReactNode;
}

export const AsyncSelectInputSingle = (props: AsyncSelectInputSingleProps) => {
    const viewProps = useAsyncSelectInputSingle(props);

    return (
        <div
            id={props.id || ID}
            className={props.className || 'form-group'}>
            <label>
                {props.required && <span className='text-danger me-1'>&#9679;</span>} {props.label}
            </label>
            <AsyncSelect
                styles={styles}
                classNames={{
                    control: () =>
                        props.useConditionedStyling === false
                            ? 'form-control'
                            : getClassName(viewProps.touched, viewProps.valid, props.value == null ? undefined : JSON.stringify(props.value))
                }}
                isClearable={props.isClearable}
                isDisabled={props.isDisabled}
                value={viewProps.findValue()}
                cacheOptions={props.cacheOptions}
                loadOptions={props.loadOptions}
                defaultOptions={props.options}
                minMenuHeight={300}
                placeholder={props.placeholder}
                noOptionsMessage={props.noOptionsMessage}
                onChange={(newValue: { value: string; label: string }) => {
                    viewProps.changeValue(newValue);
                    props.onChange && props.onChange(newValue);
                    viewProps.isValid();
                }}
                onFocus={() => {
                    viewProps.changeTouched(true);
                    props.onFocusChange && props.onFocusChange();
                }}
                onInputChange={props.onInputChange}
                onMenuScrollToBottom={props.onMenuScrollToBottom}
            />
            {viewProps.valid === false && viewProps.touched === true && (
                <span className='badge bg-gradient-danger mt-2'>
                    <small>{props.errorMessage ? props.errorMessage : 'Please select a valid option.'}</small>
                </span>
            )}
        </div>
    );
};

const styles = {
    control: (baseStyles: any) => ({
        ...baseStyles,
        boxShadow: 'none',
        minWidth: '190px',
        padding: '1.204px 0px 1.204px 10px',
        borderRadius: '0.5rem'
    }),
    menu: (baseStyle: any) => ({
        ...baseStyle,
        zIndex: 9999
    }),
    valueContainer: (baseStyle: any) => ({
        ...baseStyle,
        padding: '0px'
    })
};
